import * as Sentry from "@sentry/react";
import { Environment } from "../Environments";

function envToEnvString(environment: Environment) {
  switch (environment) {
    case "prd":
      return "production";
    case "tst":
      return "test";
    case "acc":
      return "acceptance";
    default:
      return "development";
  }
}

function envToDebug(environment: Environment) {
  switch (environment) {
    case "tst":
    case "dev":
      return true;

    case "acc":
    case "prd":
    case "unknown":
    default:
      return false;
  }
}

export function addStateBreadCrumb(name: string, state: any) {
  Sentry.addBreadcrumb({
    type: "default",
    level: "info",
    category: `${name}-state`,
    message: `State: ${state}`,
  });
}

export function addLoginChallenge(challenge: string | null | undefined) {
  Sentry.setTag("login_challenge", challenge);
}

export function addConsentChallenge(challenge: string | null | undefined) {
  Sentry.setTag("consent_challenge", challenge);
}

export function addProcessId(processId: string | null | undefined) {
  Sentry.setTag("processid", processId);
}

export function init(dsn: string, environment: Environment, release: string) {
  Sentry.init({
    dsn: dsn,
    maxBreadcrumbs: 150,
    debug: envToDebug(environment),
    release: release,
    environment: envToEnvString(environment),
    integrations: [
      Sentry.breadcrumbsIntegration({
        console: false,
        dom: false,
        fetch: true,
        history: true,
        xhr: true,
      }),
      Sentry.httpClientIntegration(),
      {
        name: "DeduplicateBreadcrumbs",
        processEvent(event) {
          if (!event.breadcrumbs) return event;

          const map = new Map<string, Sentry.Breadcrumb>();
          event.breadcrumbs.forEach((breadCrumb) => {
            const key = `${breadCrumb.category}${JSON.stringify(
              breadCrumb.data,
            )}${breadCrumb.level}${breadCrumb.message}${breadCrumb.type}`;

            const value = map.get(key);
            if (value) {
              value.data!["_repeats"] += 1;
            } else {
              if (breadCrumb.data) {
                breadCrumb.data["_repeats"] = 1;
              } else {
                breadCrumb.data = { _repeats: 1 };
              }

              map.set(key, breadCrumb);
            }
          });

          event.breadcrumbs = [...map.values()];
          return event;
        },
      },
    ],
  });

  if (document) {
    document.addEventListener("visibilitychange", () => {
      Sentry.addBreadcrumb({
        type: "default",
        level: "info",
        category: "visibility",
        message: `Document visibility: ${!document.hidden}`,
      });
    });
  }
}
